import script from "./CreateDeductionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateDeductionPage.vue?vue&type=script&setup=true&lang=js"

import "./CreateDeductionPage.vue?vue&type=style&index=0&id=78381c9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78381c9a"]])

export default __exports__